import { Link, NavLink } from 'react-router-dom';
import { LogOut, Shield, Settings, User as UserIcon, Archive as ArchiveIcon, Newspaper, Mail } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';

export default function Header() {
  const { user, logout } = useAuth();

  return (
    <header className="sticky top-0 z-20 border-b border-gray-200 bg-white/90 backdrop-blur">
      <div className="mx-auto flex h-[64px] max-w-6xl items-center justify-between px-6">
        <Link to="/" className="flex items-center gap-3">
          <img src="/bd-color.svg" alt="BuyDubai" className="h-7 w-auto" />
          <div className="hidden border-l border-gray-200 pl-3 sm:block">
            <div className="text-[11px] font-semibold uppercase tracking-wider text-gray-500">
              Intelligence Feed
            </div>
          </div>
        </Link>

        {user && (
          <div className="flex items-center gap-4">
            <nav className="hidden items-center gap-1 md:flex">
              <NavLink
                to="/"
                end
                className={({ isActive }) =>
                  `btn-ghost ${isActive ? 'bg-teal-light text-teal' : ''}`
                }
              >
                <Newspaper className="h-4 w-4" />
                Dnes
              </NavLink>
              <NavLink
                to="/archive"
                className={({ isActive }) =>
                  `btn-ghost ${isActive ? 'bg-teal-light text-teal' : ''}`
                }
              >
                <ArchiveIcon className="h-4 w-4" />
                Archív
              </NavLink>
              <NavLink
                to="/newsletters"
                className={({ isActive }) =>
                  `btn-ghost ${isActive ? 'bg-teal-light text-teal' : ''}`
                }
              >
                <Mail className="h-4 w-4" />
                Newslettery
              </NavLink>
              <NavLink
                to="/profile"
                className={({ isActive }) =>
                  `btn-ghost ${isActive ? 'bg-teal-light text-teal' : ''}`
                }
              >
                <UserIcon className="h-4 w-4" />
                Profil
              </NavLink>
              {user.role === 'admin' && (
                <NavLink
                  to="/admin/sources"
                  className={({ isActive }) =>
                    `btn-ghost ${isActive ? 'bg-teal-light text-teal' : ''}`
                  }
                >
                  <Settings className="h-4 w-4" />
                  Admin
                </NavLink>
              )}
            </nav>

            <div className="flex items-center gap-3 border-l border-gray-200 pl-4">
              <Link to="/profile" className="flex items-center gap-3 hover:opacity-80">
                <div className="text-right">
                  <div className="text-sm font-semibold text-dark">{user.name}</div>
                  <div className="flex items-center justify-end gap-1 text-[11px] uppercase tracking-wide text-gray-500">
                    {user.role === 'admin' && <Shield className="h-3 w-3" />}
                    {user.role}
                  </div>
                </div>
                {user.pictureUrl ? (
                  <img
                    src={user.pictureUrl}
                    alt=""
                    className="h-9 w-9 rounded-full"
                    referrerPolicy="no-referrer"
                  />
                ) : (
                  <div className="grid h-9 w-9 place-items-center rounded-full bg-gray-100 font-bold text-gray-600">
                    {user.name[0]?.toUpperCase()}
                  </div>
                )}
              </Link>
              <button
                onClick={logout}
                className="rounded-md p-2 text-gray-500 hover:bg-gray-100"
                title="Odhlásit"
              >
                <LogOut className="h-4 w-4" />
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
